export default "__VITE_ASSET__B2hvNkPs__"